interface FileUploadResult {
  id: string;
  file: File;
  message: string;
  uploaded: boolean;
}

export default FileUploadResult;
